<template>
  <div style="position: absolute; right: 0.75rem; top: 0; z-index: 1;">
    <div class="has-text-right">
      <a @click.prevent="open = !open" style="padding-bottom: 11px;" class="has-text-primary is-block">
        <span class="icon">
          <i class="fas fa-filter"></i>
        </span>
        <span>Filter</span>
      </a>
    </div>
    <b-collapse v-if="open" class="box" aria-id="contentIdForA11y3" :open="open" style="margin-bottom: 10px; padding: 10px;">
      <div class="columns">
        <div class="column">
          <div class="field cari-post">
            <label for="" class="label has-text-grey font-primary"><small>Pencarian</small></label>
            <div class="control">
              <i class='uil uil-search'></i>
              <input type="text" v-model="search" class="input is-medium" placeholder="Cari..."/>
            </div>
          </div>
        </div>
      </div>

      <a class="button is-primary" @click.prevent="clickHandler">
        <span class="icon"><i class="fas fa-filter"></i></span>
        <span>Terapkan</span>
      </a>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: {
    dataProvider: {
      type: Object,
      required: true
    },
    clickHandler: {
      type: Function,
      default: () => {}
    }
  },

  computed: {
    search: {
      get() {
        const search = collect(this.dataProvider.criterion).where('criteria', 'name,description,class_name').first();

        return !this.isEmpty(search) ? search.value : '';
      },
      set(val) {
        this.dataProvider['criterion'] = collect(this.dataProvider.criterion).map((c) => {
          if (c.criteria == 'name,description,class_name') {
            c['value'] = val;
          }

          return c;
        }).toArray();
      }
    },
  },

  data() {
    return {
      open: false
    }
  }
}
</script>
